import { Chip, Paper, Table, TableHead, TableRow, TableCell, TableBody, TableContainer } from "@mui/material";
import { Link } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { alphabeticalSort } from "../../utils";

const mapColor = (color, status) => {
  if (status && status.toLowerCase() === "no activity") {
    return "default"; // gray
  }
  switch (color.toLowerCase()) {
    case "green":
      return "success";
    case "red":
      return "error";
    case "yellow":
    case "amber":
      return "warning";
    default:
      return "info";
  }
};

const setRedirects = {
  "/fidelity/realtime": "/fidelity/realtime",
  "/fidelity/prod/realtime": "/fidelity/prod/realtime",
  // "/fidelity/stage/realtime": "/fidelity/stage/realtime",
  // "/fidelity/simulation/realtime": "/fidelity/simulation/realtime",
  "/fidelity/uat/realtime": "/fidelity/uat/realtime",
  "/fidelity/stage/realtime": "/fidelity/stage/realtime",
  "/fidelity/simulation/realtime": "/fidelity/simulation/realtime",
  "/amazon/realtime": "/amazon/realtime",
  "/amazon/prod/realtime": "/amazon/prod/realtime",
  "/amazon/uat/realtime": "/amazon/uat/realtime",
}

export const ApiStatusTable = ({data, sortKey, redirectUrl}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Service</TableCell>
            <TableCell>Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .sort((a, b) => alphabeticalSort(a, b, sortKey))
            .map((row) => (
              <TableRow
                key={row[sortKey]}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
              >
                <TableCell style={{ width: "15%" }}>
                  <Chip
                    label={
                      row.status && row.status.toLowerCase() === "no activity"
                        ? (
                            <span style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              height: 24,
                              width: 24,
                              fontSize: 24,
                              fontWeight: 700
                            }}>-</span>
                          )
                        : (["green"].includes(row.color.toLowerCase()) ? (
                            <DoneIcon fontSize="medium" />
                          ) : (
                            <CloseIcon fontSize="medium" />
                          ))
                    }
                    color={mapColor(row.color, row.status)}
                    sx={{ minWidth: 32, height: 32, p: 0 }}
                  />
                </TableCell>
                <TableCell style={{ width: "45%" }}>
                  {row[sortKey]}
                </TableCell>
                <TableCell>
                  {/* {user.roles.includes(USER_TYPE.INTERNAL) ? (
                              <Link to="/fidelity/realtime">{row.status}</Link>
                            ) : (
                              row.status
                            )} */}
                  <Link
                    to={setRedirects[redirectUrl.toLowerCase() || ""]}
                    state={{ eventLabel: row[sortKey] }}
                    // category has a title here with sort key
                  >
                    {row.status}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
